"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = Alert;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _Icons = require("./Icons");
var _Colors = require("./Colors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function Alert(props) {
  var _a;
  var getIcon = function getIcon() {
    switch (props.variant) {
      case 'info':
        return /*#__PURE__*/_react["default"].createElement(_Icons.InfoIcon, null);
      case 'success':
        return /*#__PURE__*/_react["default"].createElement(_Icons.SuccessIcon, null);
      case 'warning':
        return /*#__PURE__*/_react["default"].createElement(_Icons.WarningIcon, null);
      case 'error':
        return /*#__PURE__*/_react["default"].createElement(_Icons.ErrorIcon, null);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    mb: props.margin === undefined ? 2 : props.margin
  }, /*#__PURE__*/_react["default"].createElement(_material.Card, {
    variant: props.plain ? 'outlined' : 'elevation',
    elevation: props.plain ? undefined : (_a = props.elevation) !== null && _a !== void 0 ? _a : 2,
    style: props.plain ? {
      borderColor: (0, _Colors.getColor)(props.variant)
    } : undefined
  }, /*#__PURE__*/_react["default"].createElement(_material.CardHeader, {
    avatar: /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
      style: {
        backgroundColor: (0, _Colors.getColor)(props.variant)
      }
    }, getIcon()),
    title: props.title,
    subheader: props.subheader,
    action: props.button
  }))));
}